<template>
    <drop-pane-button :icon="icon" :panename="name" ref="button" :tabindex="tabindex"
            class="editbutton" :disabled="disabled" @show="onShow" :triggerHide="triggerHide">
        <template v-slot:icon>
            <slot></slot>
        </template>
        <div class="palettewrap">
            <div class="palette" @keydown="onKeyDown" ref="palette" tabindex="0">
                <div v-for="(r, ind) in palette" :key="`r-${ind}`" :class="`paletterow rownum_${ind}`">
                    <div v-for="(c, ind2) in r" :key="`r-${ind}-c-${ind2}`"
                            :class="{ palettecell: true, [`colnum_${ind2}`]: true,
                                selected: ((coords.x === ind2) && (coords.y === ind)) }"
                            role="button" :aria-selected="((coords.x === ind2) && (coords.y === ind))"
                            :title="c.colour" @mouseover="onMouseOver(ind2, ind)" @click="selectCharacter">
                        {{palette[ind][ind2]}}
                    </div>
                </div>
            </div>
        </div>
    </drop-pane-button>
</template>

<script>
import DropPaneButton from '@/components/dropPaneButton';
import split from 'lodash/split';

export default {
  name: 'specialCharPicker',
  components: { DropPaneButton },
  data() {
    return {
      coords: { x: 0, y: 0 }
    };
  },
  props: {
    icon: [String, Array],
    disabled: Boolean,
    characters: {
      type: Array,
      required: true
    },
    name: String,
    triggerHide: Boolean,
    tabindex: {
      Type: [ Number, String ],
      default: 0
    }
  },
  methods: {
    onMouseOver(x, y) {
      this.coords = { x, y };
    },
    onKeyDown(evt) {
      if (evt.key === 'ArrowDown') {
        this.coords.y++;
      } else if (evt.key === 'ArrowUp') {
        this.coords.y--;
      } else if (evt.key === 'ArrowLeft') {
        this.coords.x--;
      } else if (evt.key === 'ArrowRight') {
        this.coords.x++;
      } else if (evt.key === 'Escape') {
        this.$refs.button.hide();
      } else if ((evt.key === ' ') || (evt.key === 'Enter')) {
        this.selectCharacter();
      }
      evt.stopPropagation();

      if (this.coords.x < 0) {
        this.coords.x = 0;
      } else if (this.coords.x >= this.palette[0].length) {
        this.coords.x = this.palette[0].length - 1;
      } else if (this.coords.y < 0) {
        this.coords.y = 0;
      } else if (this.coords.y >= this.palette.length) {
        this.coords.y = this.palette.length - 1;
      }
    },
    selectCharacter() {
      const chr = this.palette[this.coords.y][this.coords.x];
      let unicode;
      if (chr.length === 1) {
        unicode = chr.charCodeAt(0);
      } else {
        unicode = (chr.charCodeAt(0) - 0xD800) * 0x400 + (chr.charCodeAt(1) - 0xDC00) + 0x10000;
      }
      this.$emit('select', `&#${unicode};`);
      this.$refs.button.hide();
    },
    onShow() {
      this.$nextTick(() => this.$refs.palette.focus());
    },
    onToolbarAction(action, tb) {
      this.$refs.button.onToolbarAction(action, tb);
    }
  },
  computed: {
    palette() {
      return this.characters.map(r => split(r, ''));
      /*
      return this.characters.map(r => {
        let row = [];
        for (let i = 0; i < r.length; i++) {
          const ch = r.charAt(i);
          if ((ch < '\ud800') || (ch >= '\ue000')) {
            row.push(ch);
          } else {
            row.push(ch + r.charAt(++i));
          }
        }
        return row;
      }); */
    }
  }
};
</script>

<style scoped lang="scss">
    @import '../assets/bootstrap-style.scss';

    .palette {
        margin: 5px 5px 0 5px;
        .paletterow {
            height: 1.5em;
            white-space: nowrap;

            .palettecell {
                padding: 0;
                margin: 0;
                width: 1.5em;
                height: 1.5em;
                overflow: hidden;
                display: inline-block;
                text-align: center;
                box-sizing: border-box;;
                &.selected {
                    border: 1px solid $gray-400;
                }
            }
        }
    }

</style>
